import { useState } from 'react';
import { Navigate } from 'react-router-dom';

import { Button } from '../components/ui/Button.jsx';
import { useTranslation } from '../i18n/useTranslation.js';

import { usePlatformAuth } from './PlatformAuthContext.jsx';
import './platform.css';

/**
 * Anmeldung der Anbieterebene.
 *
 * Ein eigenes Konto mit eigenem Passwort, getrennt von der normalen Anmeldung.
 * Wer beides braucht, meldet sich zweimal an - dafür können beide Sitzungen
 * gleichzeitig offen sein, und ein gesperrter Mandant sperrt den Anbieter nicht
 * aus seinem eigenen Bereich aus.
 */
export function PlatformLoginPage() {
  const { signIn, isAuthenticated } = usePlatformAuth();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  if (isAuthenticated) {
    return <Navigate to="/platform/tenants" replace />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await signIn(email, password);
    } catch (err) {
      setError(err?.message || t('platform.login.failed'));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="pf-login">
      <form className="pf-login-card" onSubmit={handleSubmit}>
        <div className="pf-brand">
          <span className="pf-mark" aria-hidden="true" />
          <span>RSZ ERP</span>
          <span className="pf-badge">{t('platform.badge')}</span>
        </div>
        <h1>{t('platform.login.title')}</h1>
        <p className="muted text-sm" style={{ margin: 0 }}>{t('platform.login.hint')}</p>

        <label className="field">
          <span className="field-label">{t('common.email')}</span>
          <input
            className="input"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </label>
        <label className="field">
          <span className="field-label">{t('common.password')}</span>
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </label>

        {error && <div className="alert danger">{error}</div>}

        <Button type="submit" variant="primary" disabled={submitting}>
          {submitting ? t('platform.login.cta.loading') : t('platform.login.cta')}
        </Button>
      </form>
    </div>
  );
}
